module.exports = __webpack_public_path__ + "static/media/Person8.b590e646.png";